import { useApolloClient, useMutation, useQuery } from '@apollo/client'
import { AuthContext } from '@deltek/specification-client/core/Configurations/AuthContext'
import { InsertCurrentUserInfoMutation } from '@deltek/specification-client/core/GraphQL/Mutations/currentUserInfo.mutations'
import { CurrentUserInfoQuery } from '@deltek/specification-client/core/GraphQL/Queries/currentUserInfo.queries'
import { CurrentUserInfoResponse } from '@deltek/specification-client/core/Models/currentUserInfo'
import React, { useContext, useEffect } from 'react'

const CurrentUserConfiguration: React.FC = ({ children }) => {
    const client = useApolloClient()
    const { currentUserInfo } = useContext(AuthContext)
    const { data: currentUserInfoResponse } = useQuery<CurrentUserInfoResponse>(
        CurrentUserInfoQuery
    )
    const [insertCurrentUserInfo] = useMutation<CurrentUserInfoResponse>(
        InsertCurrentUserInfoMutation
    )

    useEffect(() => {
        if (currentUserInfo && !currentUserInfoResponse) {
            insertCurrentUserInfo({
                variables: {
                    currentUserInfo,
                },
            })
        }
    }, [
        currentUserInfo,
        currentUserInfoResponse,
        insertCurrentUserInfo,
        client,
    ])

    return <>{children}</>
}

export default CurrentUserConfiguration
